import { useQuery } from '@tanstack/react-query';
import { sessionSchema, type Session } from '@product-portal/shared';
import { apiFetch, isApiError } from '@/lib/api';
import { setShortNameHints } from '@/lib/format';

export const SESSION_QUERY_KEY = ['session'] as const;

/** Current session (no token): null when not signed in. */
export function useSession() {
  return useQuery({
    queryKey: SESSION_QUERY_KEY,
    queryFn: async (): Promise<Session | null> => {
      try {
        const session = sessionSchema.parse(await apiFetch('/api/session'));
        setShortNameHints(session.shortNames);
        return session;
      } catch (error) {
        if (isApiError(error, 401)) return null;
        throw error;
      }
    },
    retry: false,
    staleTime: 60_000,
  });
}
